import { compose, setDisplayName } from 'recompose';

import withDealerTimezone from './withDealerTimezone';
import SchedulePanel from './SchedulePanel';

export default compose(
  setDisplayName('RotationSchedulePanel'),
  withDealerTimezone, // wire it up to the API
)(SchedulePanel);



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/index.js